import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileServicielle = ({ title, subtitle, image, alt, CTA: { URL, analytics, label } }) => {
   return (
      <a
         href={URL}
         {...attributesAnalytics(analytics)}
         class="tuile-servicielle lien-composite-before"
      >
         <div class="content">
            <div class="left-content">
               <img src={`${image}?saveas=webp`} alt={alt || ''} loading="lazy" />
            </div>
            <div class="right-content">
               <h3 class="h4 m-0 p-0">
                  <strong class="title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
                  <span class="subtitle" dangerouslySetInnerHTML={{ __html: tagParser(subtitle) }} />
               </h3>
            </div>
         </div>
         <span class="o-link-arrow">{label}</span>
      </a>
   )
}
